/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportProgressDtoTasks } from './ImportProgressDtoTasks';
import {
    ImportProgressDtoTasksFromJSON,
    ImportProgressDtoTasksFromJSONTyped,
    ImportProgressDtoTasksToJSON,
    ImportProgressDtoTasksToJSONTyped,
} from './ImportProgressDtoTasks';

/**
 * 
 * @export
 * @interface ImportProgressDto
 */
export interface ImportProgressDto {
    /**
     * 
     * @type {string}
     * @memberof ImportProgressDto
     */
    importId?: string;
    /**
     * 
     * @type {ImportProgressDtoTasks}
     * @memberof ImportProgressDto
     */
    tasks?: ImportProgressDtoTasks | null;
}

/**
 * Check if a given object implements the ImportProgressDto interface.
 */
export function instanceOfImportProgressDto(value: object): value is ImportProgressDto {
    return true;
}

export function ImportProgressDtoFromJSON(json: any): ImportProgressDto {
    return ImportProgressDtoFromJSONTyped(json, false);
}

export function ImportProgressDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportProgressDto {
    if (json == null) {
        return json;
    }
    return {
        
        'importId': json['importId'] == null ? undefined : json['importId'],
        'tasks': json['tasks'] == null ? undefined : ImportProgressDtoTasksFromJSON(json['tasks']),
    };
}

export function ImportProgressDtoToJSON(json: any): ImportProgressDto {
    return ImportProgressDtoToJSONTyped(json, false);
}

export function ImportProgressDtoToJSONTyped(value?: ImportProgressDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'importId': value['importId'],
        'tasks': ImportProgressDtoTasksToJSON(value['tasks']),
    };
}

